import React from 'react';
import { Trans } from '@lingui/react/macro';

import TrustLogo from '@rover/icons/svg/trust-logo.svg';
import { Box, Flex, Paragraph } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';

export const bannerTextEU = (): JSX.Element => (
  <Trans>
    All sitters pass through an <b>ID verification process</b> and are <b>approved by our team</b>{' '}
    of sitter specialists.
  </Trans>
);
export const bannerTextNA = (): JSX.Element => (
  <Trans>
    All sitters pass a <b>basic background check</b> by a third-party provider and are{' '}
    <b>approved by our team</b> of sitter specialists.
  </Trans>
);

export type Props = {
  userInEurope: boolean;
};

const SearchTrustSafetyBanner = ({ userInEurope }: Props): JSX.Element => {
  const theme = useTheme();
  return (
    <Box display={['flex', 'none']} flexDirection="column" alignItems="flex-start" paddingTop="12x">
      <Box
        sx={{ backgroundColor: theme.background.secondary }}
        borderRadius={theme.radii.secondary}
        border={`${theme.borderWidth.secondary} solid ${theme.colors.border.info}`}
        padding="4x"
        margin="4x"
        flexDirection="column"
        // do not display on desktop
        display={['flex', 'none']}
      >
        <Flex alignItems="flex-start" alignSelf="stretch">
          <Box>
            <TrustLogo />
          </Box>
          <Paragraph size="100" marginLeft="6x" marginBottom="0x">
            {userInEurope ? bannerTextEU() : bannerTextNA()}
          </Paragraph>
        </Flex>
      </Box>
    </Box>
  );
};

export default SearchTrustSafetyBanner;
